import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from "@angular/core";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (localStorage.getItem('accessToken') === null || localStorage.getItem('accessToken') === undefined || localStorage.getItem('accessToken').length === 0) {
      return next.handle(req);
    }

    const cloneReq = req.clone({
      headers: req.headers.set(
        'Authorization',
        localStorage.getItem('accessToken')
      ),
    });
    return next.handle(cloneReq);
  }
}
